const message = {
  HOTQUESTIONS: "热门问题",
  Q1: "您是想咨询以下内容吗？",
  TELLMEREASON: "可以告诉我不满意的原因吗？我会努力改进哒~",
  VIEWALL: "查看全部",
  MYHOMEPAGE: "个人中心",
  RECOGNITION: "谢谢您的认可，我会继续努力哒~",
  IWANTTOASK: "我想问...",
  YOUMAYASK: "我猜您想了解:",
  FAQLIST: "企业热榜",
  HOT: "热",
  AllAPPLICATIONS: "全部应用",
  MORE: "更多",
  FEEDBACKMSG: "已经收到您的反馈了！我会好好改进的~",
  MORESKILL: "更多技能",
  GREETING: "Hi，%s，我是%s，%s",
  FEEDBACK: "提交反馈",
};

export default message;
